//Frontend/src/unicodex_ui/pages/OpsDashboardPage.jsx
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ManufacturerNav from "../components/ManufacturerNav";
import { clearPortalSession, getStoredPortalUser } from "../services/authApi";
import "../styles/PortalBusiness.css";

function OpsDashboardPage() {
  const navigate = useNavigate();
  const user = getStoredPortalUser();

  const links = useMemo(
    () => [
      { to: "/portal/ops", label: "Ops" },
      { to: "/portal/purchasing", label: "Purchasing" },
      { to: "/portal/inventory", label: "Inventory" },
    ],
    []
  );

  function signOut() {
    clearPortalSession();
    navigate("/portal/login", { replace: true });
  }

  return (
    <section className="ucx-section ucx-portal-page">
      <div className="ucx-container">
        <ManufacturerNav
          title="Business Portal"
          subtitle={user?.email || "Signed in"}
          links={links}
          onSignOut={signOut}
        />

        <div className="ucx-portal-panel">
          <div className="ucx-portal-head">
            <div>
              <h1 className="ucx-portal-title">Ops (Org Admin)</h1>
              <p className="ucx-portal-sub">
                Jump to operational modules. (System-admin functions remain in the admin app.)
              </p>
            </div>
            <div className="ucx-portal-actions">
              <button className="ucx-btn ucx-btn-primary" type="button" onClick={() => navigate("/portal/purchasing")}>
                Purchasing
              </button>
              <button className="ucx-btn ucx-btn-outline" type="button" onClick={() => navigate("/portal/inventory")}>
                Inventory
              </button>
            </div>
          </div>

          <div className="ucx-portal-grid">
            <div className="ucx-portal-card">
              <div className="ucx-portal-card-label">Purchasing</div>
              <div className="ucx-muted">Suppliers, POs, goods receipts</div>
              <div style={{ marginTop: 10 }}>
                <button className="ucx-btn ucx-btn-outline" type="button" onClick={() => navigate("/portal/purchasing")}>
                  Open
                </button>
              </div>
            </div>

            <div className="ucx-portal-card">
              <div className="ucx-portal-card-label">Inventory</div>
              <div className="ucx-muted">Stock levels, movements, adjustments</div>
              <div style={{ marginTop: 10 }}>
                <button className="ucx-btn ucx-btn-outline" type="button" onClick={() => navigate("/portal/inventory")}>
                  Open
                </button>
              </div>
            </div>

            <div className="ucx-portal-card">
              <div className="ucx-portal-card-label">Next</div>
              <div className="ucx-muted">Day 19+ POS, accounting, logistics</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OpsDashboardPage;
